"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitConfig = void 0;
var web_ui_framework_1 = require("@gruposantander/web-ui-framework");
Object.defineProperty(exports, "getInitConfig", { enumerable: true, get: function () { return web_ui_framework_1.getInitConfig; } });
//# sourceMappingURL=index.js.map